import React from "react";
import "../../styles/m3d-vantagens.css";
import trofeu from '../../asssets/trofeu.svg';

export default function PremiosSection() {
  return (
    <section className="premios">
      <h2>Prêmios disponíveis</h2>

      <div className="premios-cards">

        <div className="premio-card">
          <h3>1.000 pts</h3>
          <img src={trofeu} alt="Troféu" />
          <p>5 Imagens Realistas 3D FULL HD</p>
          <button className="btn-primary">Resgatar</button>
        </div>

        <div className="premio-card destaque">
          <span className="badge">Mais vantajoso</span>
          <h3>1.800 pts</h3>
          <img src={trofeu} alt="Troféu" />
          <p>5 Imagens 3D FULL HD + Tour Virtual 3D</p>
          <button className="btn-primary">Resgatar</button>
        </div>

      </div>
    </section>
  );
}
